/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('#contact-form-Floors').on('input',function(e){
 $('.form__radio input[name="contact[Room Construction Floors]"]').prop('checked', false);
});


$('#contact-form-Walls').on('input',function(e){
 $('.form__radio input[name="contact[Room Construction Walls]"]').prop('checked', false);
});


$('.form__radio input[name="contact[Room Construction Floors]"]').on('click change', function(e) {
 $('#contact-form-Floors').val('').removeClass('form__field--text is-filled');
});

$('.form__radio input[name="contact[Room Construction Walls]"]').on('click change', function(e) {
 $('#contact-form-Walls').val('').removeClass('form__field--text is-filled');
});


$('.collection_global_desc p').each(function() {
    var $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
        $this.remove();
});

/**
 * Instant-search dropdown: hide the price and the "Save $X" sale badge on
 * products tagged 'no-price'.
 *
 * Boost's instant-search payload doesn't carry product tags, so the Liquid
 * {% unless %} guards used on the grid/search templates can't work here.
 * Instead we resolve tags per product: from the card's data-product blob when
 * present, otherwise from /products/<handle>.js (which DOES return tags),
 * cached per handle. These selectors are dropdown-only, so the collection
 * grid, /search page and recommendations (all guarded in Liquid) are never
 * touched.
 */
(function () {
  // Dropdown-only price nodes (both class families Boost may use) plus the
  // "Save $X" sale badge overlaying the suggestion thumbnail. All dropdown-only.
  var PRICE_SEL = '.boost-sd__instant-search-results .boost-sd__product-price, ' +
                  '.boost-sd__suggestion-queries-item-amount, ' +
                  '.boost-sd__suggestion-queries-item-badge--sale';

  var cache = {}; // handle -> boolean (resolved) | Promise (in flight)

  function hide(el) { el.style.display = 'none'; }

  function handleOf(link) {
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Resolve the product handle for a price node without guessing card classes:
  // either the price sits inside the product's own <a>, or we walk up to the
  // first ancestor whose product links all agree on ONE handle. If an ancestor
  // spans multiple products we bail — never hide the wrong product's price.
  function resolveHandle(priceEl) {
    var anchor = priceEl.closest('a[href*="/products/"]');
    if (anchor) return handleOf(anchor);

    var scope = priceEl.parentElement;
    while (scope && scope !== document.body) {
      var links = scope.querySelectorAll('a[href*="/products/"]');
      if (links.length) {
        var handle = null;
        for (var i = 0; i < links.length; i++) {
          var h = handleOf(links[i]);
          if (!h) continue;
          if (handle === null) handle = h;
          else if (handle !== h) return null; // mixed products — too high, bail
        }
        return handle;
      }
      scope = scope.parentElement;
    }
    return null;
  }

  function tagsFor(priceEl) {
    var holder = priceEl.closest('[data-product]');
    if (!holder) return null;
    try {
      var data = JSON.parse(holder.getAttribute('data-product'));
      // Trust only a non-empty tags array; otherwise fall through to the fetch.
      return data && Array.isArray(data.tags) && data.tags.length ? data.tags : null;
    } catch (e) { return null; }
  }

  function noPriceFor(handle) {
    if (!(handle in cache)) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = !!(p && (p.tags || []).indexOf('no-price') !== -1);
          cache[handle] = v; // collapse to boolean; 404 caches false (no refetch loop)
          return v;
        })
        .catch(function () { delete cache[handle]; return false; }); // network error -> retry later
    }
    var v = cache[handle];
    return typeof v === 'boolean' ? Promise.resolve(v) : v;
  }

  function process(priceEl) {
    if (priceEl.__ataNoPriceDone) return;

    var tags = tagsFor(priceEl);
    if (tags) {
      priceEl.__ataNoPriceDone = true;
      if (tags.indexOf('no-price') !== -1) hide(priceEl);
      return;
    }

    var handle = resolveHandle(priceEl);
    if (!handle) return; // not resolvable yet — retry on a later mutation
    priceEl.__ataNoPriceDone = true;

    noPriceFor(handle).then(function (noPrice) {
      if (noPrice) hide(priceEl);
    });
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(PRICE_SEL)) process(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(PRICE_SEL), process);
    }
  }

  // Boost renders/re-renders the dropdown asynchronously on every keystroke;
  // scan only added subtrees (same shape as the other observers in this file).
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document.documentElement);
})();


/**
 * Freight-warning gate: products tagged 'popup_warningFreight' must show the "additional freight
 * charges" popup (snippets/freight-warning-modal.liquid) BEFORE they're added to the cart. The add
 * only goes through once the customer clicks Continue; Cancel / Esc / backdrop abandon it.
 *
 * One capture-phase click listener on window, so it runs before both theme.js (delegated
 * [data-action="add-to-cart"] handlers) and Boost's React handlers, and a confirmed add is replayed
 * as a normal click so the existing add-to-cart code runs unchanged. How each surface is resolved:
 *   - Theme buttons (PDP, quick view, featured product, Liquid product cards): the Liquid sets
 *     data-ata-freight-warning on the button, so the attribute is authoritative.
 *   - Boost grid cards: tags come from the card's data-product blob.
 *   - Boost quick view: no tags in the modal, so they're remembered (by product id) from the grid
 *     card when its Quick view button is clicked; /products/<handle>.js is the fallback.
 */
(function () {
  var modal = document.getElementById('ata-freight-modal');
  if (!modal) return;

  var TAG = modal.getAttribute('data-tag');
  var THEME_SEL = '[data-action="add-to-cart"]';
  var BOOST_SEL = '.boost-sd__btn-add-to-cart, .boost-sd__btn-buy-now, .boost-sd__button--preorder';
  var dialog = modal.querySelector('.ata-freight__dialog');
  var confirmBtn = modal.querySelector('[data-ata-freight-confirm]');

  var cache = {};         // handle -> boolean, or a pending Promise<boolean>
  var boostTags = {};     // Boost product id -> tags, captured from the grid card on quick view
  var pending = null;     // the add-to-cart button awaiting confirmation
  var passThrough = null; // the button whose next click is the confirmed replay

  function hasTag(tags) { return Array.isArray(tags) && tags.indexOf(TAG) !== -1; }

  function tagsOf(holder) {
    try {
      var data = JSON.parse(holder.getAttribute('data-product'));
      return data && Array.isArray(data.tags) && data.tags.length ? data.tags : null;
    } catch (e) { return null; }
  }

  function handleIn(scope) {
    var link = scope && scope.querySelector('a[href*="/products/"]');
    var m = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function flagForHandle(handle) {
    if (!(handle in cache)) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return (cache[handle] = hasTag(p && p.tags)); })
        .catch(function () { delete cache[handle]; return false; }); // network error: don't block the add
    }
    return cache[handle];
  }

  // true / false when known now, or a Promise<boolean> when the tags have to be fetched.
  function flagFor(btn) {
    if (btn.matches(THEME_SEL)) return btn.hasAttribute('data-ata-freight-warning');

    var card = btn.closest('.boost-sd__product-item');
    if (card) {
      var tags = tagsOf(card);
      if (tags) return hasTag(tags);
      var cardHandle = handleIn(card);
      return cardHandle ? flagForHandle(cardHandle) : false;
    }

    var boostModal = btn.closest('.boost-sd__modal');
    if (boostModal) {
      var idEl = boostModal.querySelector('[data-product-id]');
      var id = idEl && idEl.getAttribute('data-product-id');
      if (id && boostTags[id]) return hasTag(boostTags[id]);
      var modalHandle = handleIn(boostModal);
      return modalHandle ? flagForHandle(modalHandle) : false;
    }
    return false;
  }

  function replay(btn) {
    passThrough = btn;
    btn.click();
    passThrough = null;
  }

  function open(btn) {
    pending = btn;
    modal.hidden = false;
    document.documentElement.classList.add('ata-freight-open');
    confirmBtn.focus();
  }

  function close() {
    var btn = pending;
    pending = null;
    modal.hidden = true;
    document.documentElement.classList.remove('ata-freight-open');
    return btn && btn.isConnected ? btn : null;
  }

  window.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // Remember the grid card's tags as Boost's quick view opens; the modal itself carries none.
    var quickView = target.closest('.boost-sd__button--quick-view');
    if (quickView) {
      var card = quickView.closest('.boost-sd__product-item');
      var tags = card && tagsOf(card);
      if (tags) boostTags[card.getAttribute('data-product-id')] = tags;
      return;
    }

    var btn = target.closest(THEME_SEL + ', ' + BOOST_SEL);
    if (!btn || btn.disabled) return;
    if (btn === passThrough) return; // confirmed replay: let the theme / Boost handle it

    var flag = flagFor(btn);
    if (flag === false) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;

    if (flag === true) {
      open(btn);
    } else {
      flag.then(function (yes) { if (yes) open(btn); else replay(btn); });
    }
  }, true);

  confirmBtn.addEventListener('click', function () {
    var btn = close();
    if (btn) replay(btn);
  });

  Array.prototype.forEach.call(modal.querySelectorAll('[data-ata-freight-cancel]'), function (el) {
    el.addEventListener('click', function () {
      var btn = close();
      if (btn) btn.focus();
    });
  });

  // Esc cancels; Tab stays inside the dialog. Capture phase so the theme / Boost modal underneath
  // (quick view) doesn't also react to the same key.
  window.addEventListener('keydown', function (event) {
    if (modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      var btn = close();
      if (btn) btn.focus();
    } else if (event.key === 'Tab') {
      var focusables = dialog.querySelectorAll('button');
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (!dialog.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
      event.stopImmediatePropagation();
    }
  }, true);
})();



/**
 * Boost grid swatch tidy-up (band-aid, Nov 2026).
 *
 * Boost's product cards (collection grids, /search) list every colour swatch in variant order and
 * carry no stock data, while the card image is always the product's first image and the price is
 * always "From <cheapest variant>". So a card can lead with a swatch that isn't the colour pictured
 * (DALI SONIK 3: Black Ash first at full price, Walnut pictured at the sale price), and show colours
 * that are sold out (Melomania A100: Black). Per card with swatches we fetch /products/<handle>.js
 * once (cached per handle) and:
 *   - hide swatches whose value has no available variant (unless the whole product is sold out);
 *   - when the pictured colour can be identified (see picturedValue), move its swatch to the front
 *     (CSS `order` on Boost's inline-flex row, so no nodes are moved) and mark its label
 *     boost-sd__radio-label--selected. app.css frames the FIRST swatch in the DOM unless a label
 *     carries that class, so marking it moves the theme's own single frame onto the pictured
 *     colour (a separate highlight of ours showed two framed swatches). It follows swatch clicks.
 * Boost also takes the card's "was" price from a single variant (seemingly the first), so when that
 * variant has no compare-at but the cheapest ones do (SONIK 3: Black Ash first at full price), the
 * card shows a plain "From $899" with no "was" price or Save badge. For cards whose data-product
 * blob says some compare-at exceeds the minimum price while Boost shows the plain price, we add the
 * "was" price (the cheapest variants' compare-at) and a "Save $X" label in Boost's own markup.
 * Skipped for `no-price` products and when the shown price isn't the retail minimum (wholesale).
 * The proper fix belongs in Boost's product-item template (Boost admin), which could filter
 * swatches before render; remove this block once that's done.
 */
(function () {
  var CARD = '.boost-sd__product-item';
  var OPTION = '.boost-sd__product-swatch-option';
  var SELECTED = 'boost-sd__radio-label--selected';
  var PLAIN_PRICE = '.boost-sd__product-price--default';
  var cache = {}; // handle -> product JSON, null (not found), or a pending Promise

  function productFor(handle) {
    if (!(handle in cache)) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return (cache[handle] = p); })
        .catch(function () { delete cache[handle]; return null; }); // network error: retry later
    }
    return Promise.resolve(cache[handle]);
  }

  // Shopify image URLs differ in host, query string and size suffix; compare bare file names.
  function imageKey(src) {
    if (!src) return null;
    var file = String(src).split('?')[0].split('/').pop();
    return file.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z]+$)/i, '').toLowerCase();
  }

  function dataOf(card) {
    try { return JSON.parse(card.getAttribute('data-product')) || {}; } catch (e) { return {}; }
  }

  function hasTag(tags, tag) {
    if (!tags) return false;
    if (!Array.isArray(tags)) tags = String(tags).split(',');
    return tags.some(function (t) { return String(t).trim() === tag; });
  }

  function money(cents) {
    var dollars = cents / 100;
    return '$' + dollars.toLocaleString('en-AU', { minimumFractionDigits: dollars % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  // Index of the product option a swatch row belongs to: by name (data-swatch-type is the option
  // name), falling back to whichever option contains the swatch's value.
  function optionIndex(product, input) {
    var type = (input.getAttribute('data-swatch-type') || '').toLowerCase();
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var name = typeof options[i] === 'string' ? options[i] : options[i].name;
      if (String(name).toLowerCase() === type) return i;
    }
    for (var j = 0; j < options.length; j++) {
      var values = options[j].values || [];
      if (values.indexOf(input.value) !== -1) return j;
    }
    return -1;
  }

  function slug(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  // The in-stock option value pictured by image `key`, or null when we can't tell (then we don't
  // reorder or highlight at all — a wrong highlight is worse than none). In order of confidence:
  // a variant whose own image it is; the nearest earlier variant image in the gallery (galleries
  // are grouped per colour: walnut, walnut-2, black-ash, black-ash-2 ...); the value's name in the
  // file name (dali-sonik-5-walnut-2.jpg -> Walnut).
  function picturedValue(product, index, key, inStock) {
    if (!key) return null;
    var byImage = {};
    (product.variants || []).forEach(function (v) {
      var img = v.featured_image && imageKey(v.featured_image.src);
      if (img && !(img in byImage)) byImage[img] = v.options[index];
    });
    function ok(value) { return value !== undefined && inStock[value] ? value : null; }

    if (key in byImage) return ok(byImage[key]);

    var images = (product.images || []).map(imageKey);
    var at = images.indexOf(key);
    for (var i = at - 1; at !== -1 && i >= 0; i--) {
      if (images[i] in byImage) return ok(byImage[images[i]]);
    }

    var file = key.replace(/\.[a-z]+$/, '');
    var best = null;
    Object.keys(inStock).forEach(function (value) {
      var s = slug(value);
      if (s && new RegExp('(^|-)' + s + '(-|$)').test(file) && (!best || s.length > slug(best).length)) best = value;
    });
    return best;
  }

  // Move the theme's "selected" frame (app.css) onto this swatch within its row.
  function select(option) {
    var row = option.parentNode;
    Array.prototype.forEach.call(row.querySelectorAll('.' + SELECTED), function (l) { l.classList.remove(SELECTED); });
    var label = option.querySelector('.boost-sd__radio-label');
    if (label) label.classList.add(SELECTED);
  }

  function apply(card, product, options) {
    var variants = product.variants || [];
    var available = variants.filter(function (v) { return v.available; });
    if (!available.length) return; // sold-out product: leave Boost's swatches as they are

    var index = optionIndex(product, options[0].querySelector('input'));
    if (index === -1) return;
    var inStock = {};
    available.forEach(function (v) { inStock[v.options[index]] = true; });

    var mainImg = card.querySelector('.boost-sd__product-image-img--main');
    var current = picturedValue(product, index, imageKey(mainImg && (mainImg.currentSrc || mainImg.src)), inStock);
    if (card.querySelector('.' + SELECTED)) current = null; // Boost already picked one: keep it

    Array.prototype.forEach.call(options, function (option) {
      var input = option.querySelector('input');
      var value = input && input.value;
      if (!inStock[value]) option.style.display = 'none';
      if (current !== null && value === current) {
        option.style.order = '-1';
        select(option);
      }
    });
  }

  // Turn Boost's plain price into its sale layout: "From $899 ~~$1,199~~" plus a "Save $300" label.
  function addWasPrice(card, product, price) {
    if (hasTag(product.tags, 'no-price') || card.querySelector('.boost-sd__product-price--compare')) return;
    var min = product.price_min;
    var compare = 0;
    (product.variants || []).forEach(function (v) {
      if (v.price === min && v.compare_at_price > compare) compare = v.compare_at_price;
    });
    if (compare <= min) return;
    var shown = parseFloat(price.textContent.replace(/[^0-9.]/g, ''));
    if (Math.round(shown * 100) !== min) return; // not the retail price (e.g. wholesale): leave it

    price.classList.remove('boost-sd__product-price--default');
    price.classList.add('boost-sd__product-price--sale');
    var was = document.createElement('span');
    was.className = 'boost-sd__format-currency boost-sd__format-currency--price-compare boost-sd__product-price--compare';
    was.innerHTML = '<span class="boost-sd__format-currency"></span>';
    was.firstChild.textContent = money(compare);
    price.parentNode.insertBefore(was, price.nextSibling);
    var hidden = card.querySelector('.boost-sd__product-price .boost-sd__visually-hidden');
    if (hidden) hidden.textContent = 'Regular price ' + money(compare) + ', now on sale for ' + price.textContent.trim();

    var corner = card.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left');
    if (corner && !card.querySelector('.boost-sd__product-label--sale')) {
      var label = document.createElement('div');
      label.className = 'boost-sd__product-label boost-sd__product-label--text boost-sd__product-label--rounded-rectangle boost-sd__product-label--sale';
      label.innerHTML = '<span class="boost-sd__product-label-text"><span></span></span>';
      label.querySelector('span span').textContent = 'Save ' + money(compare - min) + ' ';
      corner.insertBefore(label, corner.firstChild);
    }
  }

  function process(card) {
    var options = card.querySelectorAll(OPTION);
    var swatches = options.length > 0 && !options[0].__ataSwatchDone;
    var price = card.querySelector(PLAIN_PRICE);
    var data = dataOf(card);
    // Only fetch for a missing "was" price when Boost's own data says some compare-at beats the min.
    var wasPrice = !!price && !price.__ataWasDone && Number(data.compareAtPriceMax) > Number(data.priceMin) &&
      !hasTag(data.tags, 'no-price');
    if (price) price.__ataWasDone = true;
    if ((!swatches && !wasPrice) || !data.handle) return;
    if (swatches) Array.prototype.forEach.call(options, function (o) { o.__ataSwatchDone = true; });
    productFor(data.handle).then(function (product) {
      if (!product) return;
      if (swatches && options[0].isConnected) apply(card, product, options);
      if (wasPrice && price.isConnected) addWasPrice(card, product, price);
    });
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    var card = root.closest ? root.closest(CARD) : null;
    if (card) return process(card);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll(CARD), process);
  }

  // Keep the frame on the swatch the shopper picked (Boost swaps the image but marks nothing).
  document.addEventListener('click', function (event) {
    var option = event.target && event.target.closest && event.target.closest(CARD + ' ' + OPTION);
    if (option) select(option);
  });

  // Boost renders the grid asynchronously and re-renders on filter / sort / page changes.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document.documentElement);
})();
